import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import IntlMessages from '../../util/IntlMessages';
import CustomScrollbars from '../../util/CustomScrollbars';
import { connect } from 'react-redux';
import { getNavMenuItems } from '../../components/TopNav/navMenuItems';

function navItemText(item) {
    if (item.intlId) {
        return <IntlMessages id={item.intlId} />;
    }
    return item.label;
}

class SidenavContent extends Component {
    componentDidMount() {
        this.bindMenuHandlers();
        this.markActiveFromPath();
    }

    componentDidUpdate(prevProps) {
        if (
            prevProps.location !== this.props.location ||
            prevProps.showMenu !== this.props.showMenu
        ) {
            this.bindMenuHandlers();
            this.markActiveFromPath();
        }
    }

    bindMenuHandlers() {
        const that = this;
        const root = this.menuRoot;
        if (!root) {
            return;
        }

        const menuLi = root.getElementsByClassName('menu');
        for (let i = 0; i < menuLi.length; i++) {
            menuLi[i].onclick = function (event) {
                const clickedAnchor = (event.target && event.target.tagName === 'A')
                    ? event.target
                    : that.closest(event.target, 'a');
                const href = clickedAnchor ? (clickedAnchor.getAttribute('href') || '') : '';
                // Do not stopPropagation here: React 16 attaches Link clicks on document.
                if (clickedAnchor && href && href !== 'javascript:void(0)') {
                    return;
                }

                for (let j = 0; j < menuLi.length; j++) {
                    const parentLi = that.closest(this, 'li');
                    if (menuLi[j] !== this && (parentLi === null || !parentLi.classList.contains('open'))) {
                        menuLi[j].classList.remove('open')
                    }
                }
                this.classList.toggle('open');
            }
        }
    }

    markActiveFromPath() {
        const { history } = this.props;
        const pathname = `${history.location.pathname}`;
        const root = this.menuRoot;
        if (!root) {
            return;
        }

        const activeLi = root.querySelector('a[href="' + pathname + '"]');

        try {
            const activeNav = this.closest(activeLi, 'ul');
            if (activeNav.classList.contains('sub-menu')) {
                this.closest(activeNav, 'li').classList.add('open');
            } else {
                this.closest(activeLi, 'li').classList.add('open');
            }
        } catch (error) {

        }
    }

    closest(el, selector) {
        try {
            let matchesFn;
            ['matches', 'webkitMatchesSelector', 'mozMatchesSelector', 'msMatchesSelector', 'oMatchesSelector'].some(function (fn) {
                if (typeof document.body[fn] == 'function') {
                    matchesFn = fn;
                    return true;
                }
                return false;
            });

            let parent;

            while (el) {
                parent = el.parentElement;
                if (parent && parent[matchesFn](selector)) {
                    return parent;
                }
                el = parent;
            }
        } catch (error) {

        }

        return null;
    }

    render() {
        let user = JSON.parse(localStorage.getItem('userData'));
        const items = getNavMenuItems(user);

        return (
            <CustomScrollbars className="scrollbar">
                <div ref={(el) => { this.menuRoot = el; }}>
                <ul className="nav-menu">
                    {items.map((item) => {
                        if (item.children && item.children.length) {
                            return (
                                <li key={item.id} className="menu">
                                    <a href="javascript:void(0)">
                                        <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
                                        <span className="nav-text">
                                            {navItemText(item)}
                                        </span>
                                    </a>
                                    <ul className="sub-menu">
                                        {item.children.map((child) => (
                                            <li key={child.id}>
                                                <Link className="prepend-icon" to={child.to}>
                                                    <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
                                                    <span className="nav-text">
                                                        {navItemText(child)}
                                                    </span>
                                                </Link>
                                            </li>
                                        ))}
                                    </ul>
                                </li>
                            );
                        }

                        return (
                            <li key={item.id} className="menu no-arrow">
                                <Link to={item.to}>
                                    <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
                                    <span className="nav-text">{navItemText(item)}</span>
                                </Link>
                            </li>
                        );
                    })}
                </ul>
                </div>
            </CustomScrollbars>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        showMenu: state.companyReducer.ShowMenu
    }
}

export default withRouter(connect(mapStateToProps)(SidenavContent));
